import { useTranslation } from 'react-i18next';
import opConfig from 'openpathConfig';

import { getOpParams } from 'utils/getOpParams';
import { usersTableRoute } from 'routes/constants';
import { OpBlurbPage } from 'new-components/OpBlurbPage/OpBlurbPage';

import { getAccessUrl } from '../../../altaLoginApp/helpers/getAccessUrl';

export default () => {
  const { t } = useTranslation();
  const { orgId } = getOpParams();

  const content = [
    t(
      'User management for your partner account is handled within the Access web app. This includes adding users, roles, and permissions.',
    ),
  ];

  const accessAppUrl = getAccessUrl(opConfig.ENV);
  const externalLink = `${accessAppUrl}o/${orgId}/${usersTableRoute}`;

  return (
    <OpBlurbPage
      title={t('Manage users in Access')}
      content={content}
      externalLink={externalLink}
      externalLinkText={t('Go to Access')}
    />
  );
};
